import RenderPage from "./RenderPage";

function PreRender() {
  return <RenderPage preRenderForAnimation />;
}

export default PreRender;
